import api from './api';

const SALES_INHOUSE_ROLE_ID = '0bf4c356-3571-4c76-a3c9-8a43d62b6ed3';

/**
 * Fetches a list of all users with the 'Sales In-house' role.
 */
export const getAllSales = async () => {
  try {
    const response = await api.get('/users', {
      params: {
        role_id: SALES_INHOUSE_ROLE_ID,
        limit: 1000, // Fetch a large number to get all sales
        is_active: true,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch sales users:', error);
    throw error;
  }
};
